<div class="mb-2">
  <hr />
  <div class="mt-1 mb-1 resultHeader">
    <div class="iconStyling">
        <img src="../../../../assets/images/ODHDOrange.png"
          alt="{{ 'drillHoleIcon' | translate | async }}" 
          attr.aria-label="{{ 'drillHoleIcon' | translate | async }}" aria-hidden="true">
        <span class="ml-2">
            <a (click)="openInSameTab()" (dblclick)="openInNewTab()">
              {{ 'drill.hole.record' | translate | async }}: {{ associatedAssessmentFile }}
            </a>
        </span>
    </div>
    <div class="iconStyling recordIcon">
      <img src="../../../../assets/images/record-icon-yellow.png" 
        alt="{{ 'recordIcon' | translate | async }}" 
        attr.aria-label="{{ 'recordIcon' | translate | async }}" aria-hidden="true">
    </div>
  </div>

  <div class="resultsCardContainer">
    <div *ngIf="company_hole_id" class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'company.hole.id' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ company_hole_id | highlight : this.searchTerms }}">
        {{ company_hole_id | highlight : this.searchTerms }}
      </p>
    </div>
    <div *ngIf="company_name" class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'company' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ company_name | highlight : this.searchTerms }}">
        {{ company_name | highlight : this.searchTerms }}
      </p>
    </div>
    <div *ngIf="associatedAssessmentFile" class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'associated.assessment.file' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ associatedAssessmentFile | highlight : this.searchTerms }}">
        {{ associatedAssessmentFile | highlight : this.searchTerms }}
      </p>
    </div>
    <div *ngIf="township && township.length > 0" class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'township.area' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ township | highlight : this.searchTerms }}">
        {{ township | highlight : this.searchTerms }}
      </p>
    </div>
    <div *ngIf="year_drilled" class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'year.drilled' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ year_drilled }}">
        {{ year_drilled }}
      </p>
    </div>
  </div>
</div>